import React, { useState } from "react";
import { View, TouchableOpacity, Text, StyleSheet } from "react-native";
import { useTranslation } from "react-i18next";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";
import Fonts from "../../Resources/Fonts";
import { useDevice, useScreenDimensions } from "../_layout";

const SegmentedPicker = ({ options, value, onChange }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handlePress = (index) => {
    const newValue = index === 0;
    onChange(newValue);
  };

  const Button = ({ option, index }) => (
    <TouchableOpacity
      key={option}
      style={[
        styles.segment,
        value === (index === 0) && {
          backgroundColor: "rgba(63,123,141,0.9)",
          borderColor: "rgba(63,123,141,0.9)",
        },
      ]}
      onPress={() => handlePress(index)}
      onMouseEnter={() => !isMobile && setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(null)}
    >
      <Text
        style={{
          color: value === (index === 0) ? Colors.whiteColor : Colors.grayColor,
          fontWeight: hoveredIndex === index ? "600" : "normal",
        }}
      >
        {t(option)}
      </Text>
    </TouchableOpacity>
  );

  return (
    <View style={[styles.containerPicker]}>
      <View style={[styles.segmentedControl]}>
        {options.map((option, index) => (
          <Button option={option} index={index} key={index} />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  containerPicker: {
    backgroundColor: Colors.backgroundColor,
    borderRadius: 12,
    // padding: 4,
  },
  segmentedControl: {
    flexDirection: "row",
  },
  segment: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 16,
    // borderWidth: 1,
    // borderColor: Colors.grayColor,
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 2,
    borderRadius: 12,
  },
});

export default SegmentedPicker;
